export enum IndustryOptionIdEnum {
  Clothing = 'clothing',
  WallArt = 'wall_art',
  PaperPrints = 'paper_prints',
  Drinkware = 'drinkware',
  OtherMerch = 'other_merch',
}
